import { REQUEST_URL } from "../app/constants";
import { RequestUtil } from "../utils";

export const FeedbackService = {
  getMailConfig: () => RequestUtil.get({ url: REQUEST_URL.CUSTOMER_FEEDBACK_MAIL }),

  updateMailConfig: (data: { to: string[]; cc: string[] }) =>
    RequestUtil.put({ url: REQUEST_URL.CUSTOMER_FEEDBACK_MAIL, data }),

  listLogs: (params?: { page?: number; limit?: number; topic?: string; status?: string }) =>
    RequestUtil.get({
      url: REQUEST_URL.CUSTOMER_FEEDBACK_LOGS,
      query: params || {},
    }),

  updateLog: (
    id: string,
    data: { status: string; note?: string } | FormData,
  ) =>
    RequestUtil.patch(
      {
        url: `${REQUEST_URL.CUSTOMER_FEEDBACK_LOG_DETAIL}/${id}`,
        data,
      },
      data instanceof FormData ? { "Content-Type": undefined } : {},
    ),
};
